<template>
  <div class="body">
    <el-card>
      <el-form ref="form" :model="condition" label-width="80px" @submit.native.prevent class="operationControl">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="课件名称" prop="dataName">
              <el-input size="medium" v-model="condition.dataName" @keyup.enter.native="search" clearable ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="课件简介" prop="dataIntroduction">
              <el-input v-model="condition.dataIntroduction"  @keyup.enter.native="search" clearable ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">

            <el-form-item label="创建时间" prop="date">
              <el-date-picker
                v-model="condition.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
<!--              format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"-->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="课程目录" prop="directoryId">
              <selectTree
                clearable
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList"
                :value="condition.directoryId"
                @getValue="selectTreeChange"
              ></selectTree>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="$router.push('/mall/trainingManagement/trainingResourceAdd')"
              >新增
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table class="mb20" :data="tableData" style="width: 100%" v-loading="tableLoading" height="640" element-loading-text="拼命加载中">
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column prop="dataName" label="课件名称"></el-table-column>
        <el-table-column prop="dataIntroduction" label="课件简介"></el-table-column>
        <el-table-column prop="teacherName" label="教师名称"></el-table-column>
        <el-table-column prop="totalSuggestedDuration" label="时长"></el-table-column>
<!--        <el-table-column prop="dataPrice" label="价格"></el-table-column>-->
<!--        <el-table-column prop="expireDay" label="过期时间(单位:天)"></el-table-column>-->
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isAble == 0" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="$router.push(`/mall/trainingManagement/trainingResourceUpdate?id=${scope.row.id}`)"
            >编辑
            </el-button>
            <el-button size="mini" type="danger" @click="delData(scope.row.id,0)">删除</el-button>
            <el-button
              size="mini"
              @click="delData(scope.row.id,1)"
              type="warning"
              v-if="scope.row.isAble == 0"
            >禁用
            </el-button>
            <el-button size="mini" @click="delData(scope.row.id,1)" type="success" v-else>启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

import selectTree from "@/components/common/selectTree";
import exam from "@/api/mall/exam.js";

import api from "@/api/mall/training.js";
import DIC_API from "@/api/api_dictionary";

export default {
  components: {selectTree},
  data() {
    return {
      tableData: [],

      categoryList: [], // 专业类别列表

      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      condition: {
        dataName: "",
        dataIntroduction: "",
        startCreateTime: "",
        endCreateTime: "",
        professionalCategory: "",
        directoryId: undefined,
        date: [],
      },
      catalogList: [],   //目录列表
      tableLoading: true
    };
  },
  mounted() {
    this.getCategoryList();
    this.getDataList();
    this.getCatalogList();

    window.addEventListener("pageshow", this.onShow); //不能写成this.onShow()
  },
  methods: {
    onShow() {
      this.getDataList();
    },
    /**
     * 获取专业类别列表
     */
    getCategoryList() {
      this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
    },
    /**
     * 查询课件
     */
    search(){
      this.page = 1;
      this.getDataList();
    },
    //获取课件列表
    getDataList() {
      let condition = this.condition;
      let p = {
        page: this.page,
        pageSize: this.pageSize,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
      };
      if (condition.dataName) p.dataName = condition.dataName;
      if (condition.dataIntroduction)
        p.dataIntroduction = condition.dataIntroduction;
      if (condition.professionalCategory)
        p.professionalCategory = condition.professionalCategory;
      if (condition.directoryId)
        p.directoryId = condition.directoryId;
      if (condition.date && condition.date.length > 0) {
        console.log(condition.date[1],'123')
        p.startCreateTime = new Date(condition.date[0]).getTime();
        p.endCreateTime = new Date(condition.date[1]).getTime();
      }

      this.tableLoading = true;
      api.getDataList(p).then(res => {
        this.tableData = res.data.records;

        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    /**
     * 删除或者禁用单条课件
     * status:状态(0,删除 1、禁用)
     */
    delData(dataId, status) {
      if (status == 0) {
        this.$confirm("此操作将删除该课件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          api
            .delData({
              dataId,
              status
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success("成功");
                this.getDataList();
              }
            });
        });
      } else {
        api
          .delData({
            dataId,
            status
          })
          .then(res => {
            if (res.code == 0) {
              this.$message.success("成功");
              this.getDataList();
            }
          });
      }
    },

    handleClick(row) {
      console.log(row);
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search();
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e){
      this.pageSize = e;
      this.getDataList();
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 3,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.condition.directoryId = v.id
    }
  }
};
</script>

<style scoped>
.form {
  position: relative;
}

.searchBut {
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/trainingManagement/trainingResource.vue